import { Fragment } from 'react';
import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { store } from './redux/store';
import { TuningStudio } from './views/TuningStudio';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<Background />
			<TuningStudio />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.TuningStudio)
	.build();

export default Layout;
